import { Box, Card, Stack, Typography, useTheme } from "@mui/material";
import { useCallback } from "react";
import { ButtonComponent } from "../../components/form";
import { useNavigate } from "react-router-dom";

const MapResults = ({
    results
}) => {
    const theme = useTheme();

    const navigation = useNavigate();

    const moveToCalculation = useCallback(() => {
        navigation('/calculator?type=tours');
    }, []);

    return (
        <>
            <Card
                elevation={0}
                sx={{
                    width: '100%',
                    borderRadius: {xs: '16px 16px 0px 0px', lg: '8px'},
                    marginTop: {xs: 0, lg: '12px'},
                    bottom: {xs: 65, lg: 'auto'},
                    position: {xs: 'fixed', lg: 'relative'}
                }}
            >
                <Stack
                    direction='column'
                    justifyContent='center'
                    alignItems='start'
                    p={{xs: 2, lg: 4}}
                    spacing={{xs: 0, lg: 1}}
                >
                    <Typography
                        color={theme.palette.primary.main}
                        fontWeight={700}
                        fontSize={{xs: 21, lg: 25}}
                        letterSpacing={0}
                        fontFamily='Nunito'
                    >
                        {`Total Distance: ${results.distance}`}
                    </Typography>

                    <Box
                        sx={{
                            border: '0.75px solid black',
                            borderRadius: '21px'
                        }}
                    >
                        <Typography
                            color='rgba(0, 0, 0, 1)'
                            fontWeight={300}
                            fontSize={{xs: 12, lg: 22}}
                            letterSpacing={0}
                            py={{xs: 0.5, lg: 1}}
                            px={{xs: 1, lg: 2}}
                            fontFamily='Nunito'
                        >
                            {results.elapsedTime}
                        </Typography>
                    </Box>

                    <Typography
                        color='rgba(0, 0, 0, 1)'
                        fontWeight={500}
                        fontSize={{xs: 14, lg: 18}}
                        letterSpacing={0}
                        lineHeight={1}
                        sx={{
                            paddingTop: '10px'
                        }}
                        fontFamily='Nunito'
                        pb={{xs: 2, lg: 0.5}}
                    >
                        Best route, despite the usual traffic
                    </Typography>

                    <ButtonComponent 
                        label="Proceed to Rate"
                        onClick={moveToCalculation}
                        sx={{
                            width: '100%',
                            height: {xs: '33px', lg: '45px'}
                        }}
                    />
                </Stack>
            </Card>


        </>
    );
}

export default MapResults;